import { useState, useEffect } from 'react';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SettingsForm = ({ settings, onClose, onSave }) => {
  const [upcomingEventsCount, setUpcomingEventsCount] = useState(3);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (settings) {
      setUpcomingEventsCount(settings.upcoming_events_count);
    }
  }, [settings]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const token = localStorage.getItem('token');

    try {
      await axios.put(
        `${API}/settings`,
        { upcoming_events_count: parseInt(upcomingEventsCount) },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success('Ustawienia zapisane pomyślnie');
      onSave();
    } catch (error) {
      toast.error('Błąd podczas zapisywania ustawień');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={true} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[450px]" data-testid="settings-dialog">
        <DialogHeader>
          <DialogTitle className="text-2xl" style={{ fontFamily: 'Fredoka, sans-serif' }}>
            Ustawienia
          </DialogTitle>
          <DialogDescription>
            Skonfiguruj wyświetlanie ekranów
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          <div className="space-y-2">
            <Label htmlFor="upcoming_events_count">
              Liczba wyświetlanych następnych imprez
            </Label>
            <Input
              id="upcoming_events_count"
              type="number"
              min="1"
              max="10"
              value={upcomingEventsCount}
              onChange={(e) => setUpcomingEventsCount(e.target.value)}
              required
              data-testid="upcoming-events-input"
              className="h-11"
            />
            <p className="text-sm text-gray-500">
              Określa ile nadchodzących imprez będzie wyświetlanych pod główną imprezą na ekranach
            </p>
          </div>

          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="flex-1 h-11"
              disabled={loading}
              data-testid="cancel-settings-button"
            >
              Anuluj
            </Button>
            <Button
              type="submit"
              className="flex-1 h-11 bg-gradient-to-r from-pink-500 to-purple-600 hover:from-pink-600 hover:to-purple-700 text-white font-semibold"
              disabled={loading}
              data-testid="save-settings-button"
            >
              {loading ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Zapisywanie...
                </>
              ) : (
                'Zapisz'
              )}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default SettingsForm;
